'use strict';

var chunkODXUQKOS_js = require('./chunk-ODXUQKOS.js');
require('./chunk-Z2IA5X5N.js');
var chunkO7ZPAWMD_js = require('./chunk-O7ZPAWMD.js');
var chunkXOTY7IGT_js = require('./chunk-XOTY7IGT.js');
require('./chunk-P6A6EOYX.js');
var chunkZPGIA3DZ_js = require('./chunk-ZPGIA3DZ.js');



Object.defineProperty(exports, 'ReactWebChat', {
	enumerable: true,
	get: function () { return chunkODXUQKOS_js.a; }
});
Object.defineProperty(exports, 'AlteredCopyImgSrc', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.i; }
});
Object.defineProperty(exports, 'CopyImgSrc', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.h; }
});
Object.defineProperty(exports, 'botAvatarBackgroundColor', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.b; }
});
Object.defineProperty(exports, 'botAvatarInitials', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.a; }
});
Object.defineProperty(exports, 'customPopupElementId', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.e; }
});
Object.defineProperty(exports, 'feedbackDislikeImgSrc', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.g; }
});
Object.defineProperty(exports, 'feedbackLikeImgSrc', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.f; }
});
Object.defineProperty(exports, 'userAvatarBackgroundColor', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.d; }
});
Object.defineProperty(exports, 'userAvatarInitials', {
	enumerable: true,
	get: function () { return chunkO7ZPAWMD_js.c; }
});
Object.defineProperty(exports, 'input', {
	enumerable: true,
	get: function () { return chunkXOTY7IGT_js.b; }
});
Object.defineProperty(exports, 'span', {
	enumerable: true,
	get: function () { return chunkXOTY7IGT_js.a; }
});
Object.defineProperty(exports, 'dropDownItemHoverRemoveStyle', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.d; }
});
Object.defineProperty(exports, 'dropDownItemHoverStyle', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.c; }
});
Object.defineProperty(exports, 'feedbackModuleDivClass', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.e; }
});
Object.defineProperty(exports, 'hideMainDivClass', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.b; }
});
Object.defineProperty(exports, 'showMainDivClass', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.a; }
});
Object.defineProperty(exports, 'thoughtProcessModuleDivClass', {
	enumerable: true,
	get: function () { return chunkZPGIA3DZ_js.f; }
});
